import { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Own
import confirmRegisterRequest from 'services/subscription/confirm-register';
import { useLogin } from 'core/guard-layout/use-login';

export const useConfirmRegister = (): Response => {
  const { tokenEmail } = useParams<{ tokenEmail: string }>();
  const shouldMakeRequest = useRef(true);

  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const login = useLogin();
  const confirmRegister = useCallback(async () => {
    setLoading(true);

    try {
      if (tokenEmail) {
        const data = await confirmRegisterRequest(tokenEmail);
        return login(data);
      }

      throw new Error('Invalid payload');
    } catch (error) {
      setHasError(true);
    } finally {
      setLoading(false);
    }
  }, [login, tokenEmail]);

  useEffect(() => {
    if (shouldMakeRequest.current) confirmRegister();

    shouldMakeRequest.current = false;
  }, [confirmRegister]);

  return { loading, hasError };
};

interface Response {
  loading: boolean;
  hasError: boolean;
}
